import http from '../http-engine';

export default {
    getList(params) {
        return http.get('/api/v1/firmwareTypes', { params });
    },
    delete(id) {
        return http.delete(`/api/v1/firmwareTypes/${id}`);
    },
    create(params) {
        return http.post('/api/v1/firmwareTypes', params);
    },

    update(param) {
        return http.patch(`/api/v1/firmwareTypes/${param.firmwareTypeId}`, param);
    },
    sync() {
        return http.get('/api/v1/firmwareTypes:sync');
    },
};
